module.exports = __webpack_public_path__ + "static/media/ico_pagamento-facil_new.1698f518.svg";